import React from "react";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../../_metronic/_partials/controls";
import { formatDate } from "../../../../util/Helpers";
import { useGetBalanceQuery } from "../../../../../redux/apiSlice";

const Balance = () => {
    const { isFetching, data, error, refetch } = useGetBalanceQuery();
    
    const balance = data?.data;

    const formatCurrency = (amount) => {
        if (!amount && amount !== 0) return '0.00';
        return new Intl.NumberFormat('en-NG', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    };

    return (
        <div className="py-4 px-6">
            <Card>
                <CardHeader title="Zanibal Wallet Balance">
                    <CardHeaderToolbar>
                        <button 
                            className="btn btn-light-primary font-weight-bold"
                            onClick={() => refetch()}
                            disabled={isFetching}
                        >
                            <i className={`fa fa-sync-alt mr-2 ${isFetching ? 'fa-spin' : ''}`}></i>
                            Refresh
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    {isFetching ? (
                        <div className="d-flex justify-content-center py-10">
                            <div className="spinner spinner-primary spinner-lg"></div>
                        </div>
                    ) : error ? (
                        <div className="text-center py-10">
                            <div className="alert alert-danger" role="alert">
                                <i className="fa fa-exclamation-triangle mr-2"></i>
                                Error loading balance data
                            </div>
                        </div>
                    ) : balance ? (
                        <div className="row">
                        {/* Available Balance */}
                        <div className="col-lg-6 col-md-6 mb-5">
                            <div className="bg-light-success rounded p-8 h-100">
                                <div className="d-flex align-items-center mb-3">
                                    <i className="fa fa-wallet text-success font-size-h1 mr-3"></i>
                                    <span className="text-muted font-weight-bold font-size-lg">
                                        Available Balance
                                    </span>
                                </div>
                                <span className="font-weight-boldest font-size-h1 text-dark-75 d-block">
                                    {balance.currency} {formatCurrency(balance.availableBalance)}
                                </span>
                            </div>
                        </div>
                        
                        <div className="col-lg-6 col-md-6 mb-5">
                            <div className="bg-light-success rounded p-8 h-100">
                                <div className="d-flex align-items-center mb-3">
                                    <i className="fa fa-sync text-success font-size-h1 mr-3"></i>
                                    <span className="text-muted font-weight-bold font-size-lg">
                                        Total Reservation
                                    </span>
                                </div>
                                <span className="font-weight-boldest font-size-h3 text-dark-75 d-block">
                                    {balance.currency} {formatCurrency(balance.totalReservation)}
                                </span>
                            </div>
                        </div>
                        
                        {/* Pending Balance */}
                        <div className="col-lg-6 col-md-6 mb-5">
                            <div className="bg-light-primary rounded p-8 h-100">
                                <div className="d-flex align-items-center mb-3">
                                    <i className="fa fa-clock text-primary font-size-h1 mr-3"></i>
                                    <span className="text-muted font-weight-bold font-size-lg">
                                        Pending Balance
                                    </span>
                                </div>
                                <span className="font-weight-boldest font-size-h3 text-dark-75 d-block">
                                    {balance.currency} {formatCurrency(balance.pendingBalance)}
                                </span>
                            </div>
                        </div>
                        
                        {/* Total reservation */}
                        <div className="col-lg-6 col-md-6 mb-5">
                            <div className="bg-light-success rounded p-8 h-100">
                                <div className="d-flex align-items-center mb-3">
                                    <i className="fa fa-sync text-success font-size-h1 mr-3"></i>
                                    <span className="text-muted font-weight-bold font-size-lg">
                                        Processing Balance
                                    </span>
                                </div>
                                <span className="font-weight-boldest font-size-h3 text-dark-75 d-block">
                                    {balance.currency} {formatCurrency(balance.processingBalance)}
                                </span>
                            </div>
                        </div>
                       
                    </div>
                    ) : (
                        <div className="text-center py-10">
                            <i className="fa fa-inbox text-muted font-size-h1 mb-5"></i>
                            <p className="text-muted font-size-h5">No balance data available</p>
                        </div>
                    )}
                </CardBody>
            </Card>
        </div>
    );
};

export default Balance;